import React from 'react'

function Loading() {
  return (
    <div className='page-wrapper'>
      <img src='../Assets/loading.gif' alt='loading' />
    </div>
  )
}

export default Loading
